export default __webpack_public_path__ + "static/FbTestimonial3-a56eb03fd06aa78199958b8e9603f230.jpeg";